import {css} from '../../theme/css'
import {hex2rgba} from '../../theme/theme'
import {cssTheme} from '../theme'

/** @deprecated use `import {cssTheme} from '@logistics-frontend/blocks/v2'` */
export const Theme = {
  Default: {
    Day: {
      Control: '#fce000',
      ControlMinor: '#f1f0ed',
      Background: '#ffffff',
      BackgroundInvert: '#302f2d',
      EverBlack: '#000000',
      BackgroundMinor: '#f5f4f2',
      Text: '#21201f',
      TextMinor: '#9e9b98',
      Line: '#d2d0cc',
      TextInvert: 'rgba(255, 255, 255, 1)',
      LineWeb: 'rgba(210, 208, 204, 0.5)',
      Divider: 'rgba(0, 0, 0, 0.08)',
      // Day/Focus и Day/Hover скорее всего инородные, не из дефолтной темы
      Focus: 'rgba(0, 0, 0, 0.75)',
      Hover: 'rgba(0, 0, 0, 0.05)',
      LoadingGradient: `
        linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.2) 20%,
            rgba(255, 255, 255, 0.8) 60%,
            rgba(255, 255, 255, 0)
        )`,
    },
  },
}

/** @deprecated use `import {cssTheme} from '@logistics-frontend/blocks/v2'` */
export const Colors = {
  Cinnabar: {
    Toxic: '#fc5230',
  },
  Blue: {
    Dark: '#0668BE',
    Toxic: '#0596FA',
  },
  DeliveryGrey: {
    100: '#E6E6E6',
    125: '#DDDCDA',
    150: '#D4D4D0',
    200: '#B3B3B3',
    250: '#999999',
    300: '#808080',
    350: '#666666',
    400: '#4D4D4D',
    450: '#333333',
    500: '#252525',
    550: '#1A1A1A',
  },
}

export const inputClasses = {
  textField: css`
    ${cssTheme.components.textFields.outline.bgColorError.token}: ${hex2rgba(cssTheme.colors.cinnabar.toxic.hex, 0.1)};

    & input::placeholder {
      color: ${cssTheme.default.day.textMinor};
      opacity: 1;
    }

    & input[type='number'] {
      -moz-appearance: textfield;
    }

    & input[type='tel'] {
      font-size: 16px;

      [dir='rtl'] & {
        direction: ltr;
        text-align: right;
      }
    }

    & input::-webkit-outer-spin-button,
    & input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  `,
  clearIcon: css`
    cursor: pointer;
  `,
}
